var divider_viewer_rtlignore_default = {
  "divider-container": "_9Ozd8",
  "divider-container--double": "Ppu78",
  "divider": "mwyGQ",
  "divider--single": "_9B85-",
  "divider--double": "_2TQ-7",
  "divider--dashed": "PmG8T",
  "divider--dotted": "kXgK-",
  "divider--small": "SoInI",
  "divider--medium": "gOdOu",
  "divider--large": "eGi2X",
  "divider--left": "_1H371",
  "divider--center": "Tbg9Z",
  "divider--right": "di-7t",
  "svgFixerContainer": "NcfhR",
  "emptyChar": "aYXGT"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
